import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const ClientIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg
      width={circled ? '60%' : '100%'}
      height={circled ? '60%' : '100%'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 22"
    >
      <path
        d="M17.6585 1H4.34146C3.04831 1 2 2.02335 2 3.28571V18.7143C2 19.9767 3.04831 21 4.34146 21H17.6585C18.9517 21 20 19.9767 20 18.7143V3.28571C20 2.02335 18.9517 1 17.6585 1Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M12 11.5714C12.2857 11.5714 12.4286 11.5714 12.7143 11.7143C13.2857 11.8571 13.7143 12.1429 14.1429 12.5714C14.5714 13 14.7143 13.4286 15 13.8571C15 14.1429 15.1429 14.2857 15.1429 14.5714H6.57144C6.57144 14.2857 6.57144 14.1429 6.7143 13.8571C6.85716 13.2857 7.14287 12.8571 7.57144 12.5714C8.00001 12.1429 8.42858 11.8571 8.85716 11.7143C9.00001 11.7143 9.28573 11.7143 9.42858 11.5714"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10.8572 11.8571C12.0406 11.8571 13 10.8338 13 9.57143C13 8.30907 12.0406 7.28572 10.8572 7.28572C9.67368 7.28572 8.71429 8.30907 8.71429 9.57143C8.71429 10.8338 9.67368 11.8571 10.8572 11.8571Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  </CircledIcon>
);
